import { useTranslation } from "react-i18next";
export default function SettingOptionsTranslation() {
  const { t } = useTranslation();

  const eventOptions = [
    {
      label: t("secure.facility.events.event_options.001"),
      url: "/admin/events",
    },
    {
      label: t("secure.facility.events.event_options.002"),
      url: "/admin/events-tournament",
    },
    {
      label: t("Hospitality"),
      url: "/admin/events-hospitality",
    },
    {
      label: t("Calendar"),
      url: "/admin/events-calendar",
    },
  ];

  return eventOptions;
}
